var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.33315C16.9983 10.0466 16.9902 10.7601 16.9805 11.4735C16.9687 12.3343 16.9554 13.1954 16.7395 14.0414C16.5132 14.9285 16.0667 15.6937 15.3721 16.2601C14.6401 16.857 13.7554 17.1707 12.8005 17.2288C11.534 17.3058 10.267 17.3363 9 17.3333C7.73296 17.3363 6.46593 17.3058 5.19947 17.2288C4.24458 17.1707 3.35986 16.857 2.6279 16.2601C1.93329 15.6937 1.48683 14.9285 1.26045 14.0414C1.04458 13.1954 1.03129 12.3343 1.01953 11.4735C1.00976 10.7601 1.00166 10.0466 1 9.33315C1.00166 8.6197 1.00976 7.90621 1.01953 7.19279C1.03129 6.33204 1.04458 5.47092 1.26045 4.62492C1.48683 3.73776 1.93329 2.97264 2.6279 2.40621C3.35986 1.8093 4.24458 1.49556 5.19947 1.43749C6.46593 1.36047 7.73296 1.33003 9 1.33301C10.267 1.33003 11.534 1.36047 12.8005 1.43749C13.7554 1.49556 14.6401 1.8093 15.3721 2.40621C16.0667 2.97264 16.5132 3.73776 16.7395 4.62492C16.9554 5.47092 16.9687 6.33204 16.9805 7.19279C16.9902 7.90621 16.9983 8.6197 17 9.33315Z",
    stroke: "#A9A9A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5252 9.33359C12.5252 11.2994 10.9316 12.8931 8.96572 12.8931C6.99988 12.8931 5.40625 11.2994 5.40625 9.33359C5.40625 7.36774 6.99988 5.77411 8.96572 5.77411C10.9316 5.77411 12.5252 7.36774 12.5252 9.33359Z",
    stroke: "#A9A9A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6951 4.75693C14.6951 5.31858 14.2398 5.77393 13.6781 5.77393C13.1165 5.77393 12.6611 5.31858 12.6611 4.75693C12.6611 4.19528 13.1165 3.73994 13.6781 3.73994C14.2398 3.73994 14.6951 4.19528 14.6951 4.75693Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInsta);
export default __webpack_public_path__ + "static/media/socialInsta.04c56b7bf3a6bc27a8b77bc355d14e6a.svg";
export { ForwardRef as ReactComponent };